var render, staticRenderFns
import script from "./MediaTabs.vue?vue&type=script&lang=js"
export * from "./MediaTabs.vue?vue&type=script&lang=js"
import style0 from "./MediaTabs.vue?vue&type=style&index=0&id=0549298a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0549298a",
  null
  
)

export default component.exports